import { fontSizes, fontWeights } from "theme/fonts";
import { colors } from "theme/colors";

export const theme ={
    colors,
    fontSizes,
    fontWeights,
}